module.exports = __webpack_public_path__ + "img/aeroland-client-logo-08-hover.ececb98d.png";